export default __webpack_public_path__ + "static/media/hellbound-anthology-of-science-fiction-volume-1.5d5bb5e2.jpg";